<template>
  <div v-if="!multiple">
    <AutoComplete
      @okeyto="aa => setModel(aa)"
      autocomplete="off"
      :table="input.table"
      :field="input.name"
    /> 
  </div>
</template>

<script>
import AutoComplete from "../../AutoComplete/AutoComplete.vue";

export default {
  name: "string",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "value","multiple"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  mounted() {
    this.$emit("okeyto", datalar => {
      console.log(datalar);
    });
  },
  methods: {
    setModel(newValue) {
      this.model = newValue;
      console.log(this.model, "Model Updated");
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  },
  components: { AutoComplete }
};
</script>

<style></style>
